import {
    Box,
    Button,
    Grid,
    Hidden,
    Stack,
    styled,
    Typography,
} from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';

const RespBox = styled(Box)(({ theme }) => ({
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'flex-start',
    height: '300px',
    [theme.breakpoints.down('md')]: {
        alignItems: 'center',
    },
}));

const HomePageTopSection = props => {
    const HeaderButton = styled(Button)(({ theme }) => ({
        [theme.breakpoints.up('md')]: {
            textAlign: 'center',
            padding: '16px',
            border: '3px #FFF solid',
            backgroundColor: '#00000056',
            borderRadius: '20px',
            fontSize: '2.5rem',
            '&:hover': {
                backgroundColor: '#000000ba',
                border: '3px #1f7ca8 solid',
                color: '#1f7ca8',
            },
        },
        color: props.textColor,
        textTransform: 'none',
        margin: 2,
        textAlign: 'center',
        padding: '16px',
        borderRadius: '20px',
        fontSize: '1.5rem',
        fontWeight: 400,
    }));

    const HeaderTypo = styled(Typography)(({ theme }) => ({
        [theme.breakpoints.up('md')]: {
            textAlign: 'center',
            padding: '16px',
            border: '3px #FFF solid',
            backgroundColor: '#00000056',
            borderRadius: '20px',
            fontSize: '2.5rem',
        },
        color: props.textColor,
        textTransform: 'none',
        margin: 2,
        textAlign: 'center',
        padding: '6px',
        borderRadius: '20px',
        fontSize: '1.5rem',
        fontWeight: 400,
        backgroundColor: '#1E7CA8',
        marginBottom: '-60%',
    }));

    const BackgroundImg = styled(Box)(({ theme }) => ({
        width: '100%',
        height: '780px',
        borderRadius: '75px',
        margin: '-300px 0px',
        backgroundImage: `url('${props.largeImage}')`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0px 300px',
        [theme.breakpoints.down('md')]: {
            height: '600px',
            backgroundImage: `url('${props.smallImage}')`,
            backgroundPosition: 'bottom 20%',
        },
    }));

    let history = useHistory();

    return (
        <Grid
            container
            xs={12}
            directon="row"
            justifyContent="space-around"
            alignItems="center"
            sx={{ display: 'none' }}
        >
            <Grid item xs={12}>
                <BackgroundImg />
                <RespBox width="100%">
                    {props.verified ? (
                        <Stack
                            direction="column"
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Hidden only={['xs', 'sm']}>
                                <HeaderButton
                                    onClick={event => {
                                        history.push(props.location);
                                    }}
                                >
                                    {props.title}
                                </HeaderButton>
                            </Hidden>
                            <Hidden only={['md', 'lg', 'xl']}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        height: '40px',
                                        width: '250px',
                                        borderRadius: '30px',
                                    }}
                                    onClick={event => {
                                        history.push(props.location);
                                    }}
                                >
                                    {props.buttonTitle}
                                </Button>{' '}
                            </Hidden>
                        </Stack>
                    ) : (
                        <Stack
                            direction="column"
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <HeaderTypo>Welcome to AirTeachr</HeaderTypo>
                        </Stack>
                    )}
                </RespBox>
            </Grid>
        </Grid>
    );
};

export default HomePageTopSection;
